import React from 'react';

const Pagination = (props) => {
  const renderPageNumbers = () => {
    const totalPages = props.totalPages;
    const currentPage = props.currentPage;

    // console.log('totalPages', totalPages);

    return Array(totalPages)
      .fill()
      .map((_, i) => {
        let active = '';
        if (currentPage === i + 1) {
          active = 'active';
        }

        return (
          <li onClick={(event) => onPageClick(i)} key={i} className={active}>
            <span>{i + 1}</span>
          </li>
        );
      });
  };

  const onPageClick = (page) => {
    props.onPageChange(page);
  };

  return (
    <div className="pagination hlp-flex flex-jcc">
      <ul>
        {props.currentPage > 1 ? (
          <li
            onClick={(event) => onPageClick(props.currentPage - 2)}
            className="prev">
            prev
          </li>
        ) : (
          <li className="dummy">prev</li>
        )}

        {renderPageNumbers()}

        {props.currentPage < props.totalPages ? (
          <li
            onClick={(event) => onPageClick(props.currentPage)}
            className="next">
            next
          </li>
        ) : (
          <li className="dummy">next</li>
        )}
      </ul>
    </div>
  );
};

export {Pagination};
